import {createTheme} from "@mui/material";

export const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#cbc872',
            light: '#f3ef89',
            dark: '#8c8a50',
            contrastText: '#a396b5'
        },
        secondary: {
            main: '#6536ac'
        },
        background: {
            default: '#110d17'
        }
    }
})